// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Styles */
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background-color: white;
  border-radius: 8px;
  /* max-height: 90vh; */
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease; */
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.15rem 1.35rem;
  background: var(--modal-background, var(--surface, #fff));
  color: var(--text-primary, #0f172a);
  border-bottom: 1px solid var(--border, #e2e8f0);
  border-radius: 16px 16px 0 0;
}

/* Create / Edit Test Suite modals — above fixed navbar (z-index 10000) and
   without inheriting global .modal slide/transform conflicts. */
.create-test-suite-modal-overlay,
.edit-test-suite-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11000;
  animation: instantModalOverlayFadeIn 0.12s ease-out;
}

.modal.create-test-suite-modal,
.modal.edit-test-suite-modal {
  border-radius: 8px;
  overflow-y: auto; /* keep modal content scrollable */
  overflow-x: hidden; /* prevent any horizontal bleed past rounded corners */
  background-color: #fff;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  right: auto !important;
  bottom: auto !important;
  transform: translate(-50%, -50%) !important;
  animation: none !important;
  transition: none !important;
  z-index: 11001 !important;
  max-height: min(90vh, calc(100vh - 2rem)) !important;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--text-primary, #0f172a);
}

.close-button {
  background: none;
  border: none;
  color: var(--text-muted, #64748b);
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.25rem;
  line-height: 1;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: background 0.15s ease, color 0.15s ease;
}

.close-button:hover {
  background: var(--surface-hover, #f8fafc);
  color: var(--text-primary, #0f172a);
  opacity: 1;
}

.close-button:active {
  transform: rotate(90deg) scale(0.95);
}

.modal-content {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid var(--border-color, #e9ecef);
}

/* Form Styles */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: var(--text-primary, #212529);
}

.form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-color, #ced4da);
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.2s ease;
}

.form-group input:focus {
  outline: none;
  border-color: var(--primary, #0d6efd);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
}

.form-group small {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: var(--text-muted, #6c757d);
}

.form-group small a {
  color: var(--primary, #0d6efd);
  text-decoration: none;
  margin-left: 4px;
}

.form-group small a:hover {
  text-decoration: underline;
}

/* Button Styles */
.btn-primary {
  background-color: var(--primary, #0d6efd);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-primary:hover {
  background-color: #0b5ed7;
}

.btn-primary:disabled {
  background-color: #84b4ff;
  cursor: not-allowed;
}

.btn-secondary {
  background-color: white;
  color: var(--text-primary, #212529);
  border: 1px solid var(--border-color, #ced4da);
  padding: 10px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-secondary:hover {
  background-color: var(--bg-light, #f8f9fa);
}

.btn-link {
  background: none;
  border: none;
  color: var(--primary, #0d6efd);
  padding: 0;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
}

.btn-link:hover {
  text-decoration: underline;
}

/* Project Selection Styles */
.project-selection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.project-selection-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.project-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid var(--border-color, #e9ecef);
  border-radius: 4px;
  margin-bottom: 16px;
}

.project-item {
  display: flex;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color, #e9ecef);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.project-item:last-child {
  border-bottom: none;
}

.project-item:hover {
  background-color: var(--bg-light, #f8f9fa);
}

.project-item.selected {
  background-color: rgba(13, 110, 253, 0.05);
}

.project-item .checkbox {
  margin-right: 12px;
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
}

.project-item .project-info {
  flex: 1 1;
}

.project-item .project-name {
  margin-bottom: 4px;
}

.project-item .project-key {
  font-size: 12px;
  color: var(--text-muted, #6c757d);
  background-color: var(--bg-light, #f8f9fa);
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: 8px;
}

.project-item .project-description {
  font-size: 14px;
  color: var(--text-primary, #212529);
  margin-bottom: 4px;
}

.project-item .project-lead {
  font-size: 12px;
  color: var(--text-muted, #6c757d);
}

/* File Upload Styles */
.upload-container {
  margin: 20px 0;
}

.file-upload-area {
  border: 2px dashed var(--border-color, #ced4da);
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  margin-bottom: 16px;
  transition: border-color 0.2s ease;
}

.file-upload-area:hover {
  border-color: var(--primary, #0d6efd);
}

.file-upload-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 20px;
}

.file-upload-label.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.file-upload-label svg {
  color: var(--primary, #0d6efd);
}

.file-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--bg-light, #f8f9fa);
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 12px;
  width: 100%;
}

.upload-progress {
  margin: 16px 0;
}

.progress-bar {
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-bar-fill {
  height: 100%;
  background-color: var(--primary, #0d6efd);
  border-radius: 4px;
  transition: width 0.3s ease;
  color: var(--text-dark, #212529) !important;
}

.upload-error {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #dc3545;
  background-color: #f8d7da;
  border: 1px solid #f5c2c7;
  border-radius: 4px;
  padding: 10px 12px;
  margin-top: 12px;
  font-size: 14px;
}

.upload-info {
  margin-top: 24px;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
}

.upload-info h3 {
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 12px;
}

.upload-info ol {
  margin: 0;
  padding-left: 20px;
}

.upload-info li {
  margin-bottom: 8px;
}

.upload-info li:last-child {
  margin-bottom: 0;
}

.modal-body {
  /* padding: 24px;
  overflow-y: auto;
  max-height: 60vh; */
  padding: 1.5rem;
}

.modal-footer {
  /* display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-color, #e9ecef); */
  padding: 1rem 1.5rem;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.modal-cancel-btn {
  /* background-color: white;
  color: var(--text-primary, #212529);
  border: 1px solid var(--border-color, #ced4da);
  padding: 10px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease; */
  padding: 0.5rem 1rem;
  background: #F5F5F5;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #333;

}

.modal-cancel-btn:hover {
  /* background-color: var(--bg-light, #f8f9fa); */
  background: #E9E9E9;
  color: #333;
}

.modal-cancel-btn:disabled {
  /* opacity: 0.7; */
  background: #cccccc;
  cursor: not-allowed;
}

.modal-action-btn {
  background-color: var(--primary, #0d6efd);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.modal-action-btn:hover {
  background-color: #0b5ed7;
}

.modal-action-btn:disabled {
  background-color: #84b4ff;
  cursor: not-allowed;
}

.modal-description {
  color: var(--text-muted, #6c757d);
  margin-bottom: 20px;
}

/* Checkbox Styles */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: auto;
  margin: 0;
  cursor: pointer;
}

.checkbox-label span {
  font-size: 14px;
  color: var(--text-primary, #212529);
}

/* Error Message */
.error-message {
  color: #dc3545;
  background-color: #f8d7da;
  border: 1px solid #f5c2c7;
  border-radius: 4px;
  padding: 10px 12px;
  margin-bottom: 16px;
  font-size: 14px;
}

/* Stats Group Styles for Edit Modal */
.stats-group {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 8px;
  background-color: var(--bg-light, #f8f9fa);
  padding: 12px;
  border-radius: 4px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stat-label {
  font-weight: 500;
  color: var(--text-primary, #212529);
}

.stat-value {
  color: var(--primary, #0d6efd);
  font-weight: 600;
}

/* Edit Test Suite Modal Specific Styles */
.edit-test-suite-modal .form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-color, #ced4da);
  border-radius: 4px;
  font-size: 16px;
  transition: border-color 0.2s ease;
}

.edit-test-suite-modal .form-input:focus {
  outline: none;
  border-color: var(--primary, #0d6efd);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
}

.form-error {
  color: #dc3545;
  font-size: 14px;
  margin-top: 8px;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}
 
.modal.view-mode {
  width: 60vw;
  max-width: 70vw;
  background-color: #e0e0e0;

  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.modal-body {
  overflow-y: auto;
  max-height: 70vh;
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
}

.modal-body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.modal-body::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
}

.modal-body::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 4px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-thumb-hover);
}

/* Background for the modal */
.view-mode {
  background-color: #f1f3f5 !important;
  border: 1px solid var(--border-color, #e9ecef);

}

/* Input and textarea styles inside view-mode */
.view-mode input:disabled,
.view-mode textarea:disabled {
  background-color: lightgray !important;
  color: #020202 !important;
  cursor: not-allowed;
  border: 1px solid light-dark !important;
}

/* Optional: prevent focus outlines */
.view-mode input:disabled:focus,
.view-mode textarea:disabled:focus {
  outline: #212529;
  box-shadow: #212529;

}

.btn-primary {
  background-color: #007bff;
  /* Bootstrap-style blue */
  color: white;
  border: none;
  padding: 0.5rem 1.2rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
  margin-left: auto;
}

.btn-primary:hover {
  background-color: #0056b3;

}

.modal-close {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--text-muted, #64748b);
  cursor: pointer;
  line-height: 1;
  border-radius: 8px;
}

.modal-close:hover {
  background: var(--surface-hover, #f8fafc);
  color: var(--text-primary, #0f172a);
}

.modal-header {
  background: var(--modal-background, var(--surface, #fff));
}

.modal.delete-confirm-modal {
  width: 90%;
  max-width: 450px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  top: auto;
  left: auto;
  transform: none;
}

.delete-confirm-modal .modal-body {
  padding: 1.5rem;
  text-align: center;
}

.delete-confirm-modal .modal-body p {
  margin: 0 0 0.75rem;
}

.delete-confirm-modal .delete-confirm-item-name {
  font-size: 1.125rem;
  word-break: break-word;
}

.delete-confirm-modal .modal-footer {
  justify-content: space-between;
}

@media (max-width: 480px) {
  .modal.delete-confirm-modal {
    width: 95%;
    max-width: none;
  }
}

/* Test Case action modals should open already centered, without inheriting global slide animations. */
.modal.ai-suggestions-modal,
.modal.review-panel-modal,
.modal.auto-update-modal,
.modal.version-history-modal,
.modal.edit-test-case-modal,
.modal.add-test-cases-modal {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  right: auto !important;
  bottom: auto !important;
  transform: translate(-50%, -50%) !important;
  animation: none !important;
  transition: none !important;
}

/* Link Test Cases modal — flex-centered; avoid navbar .modal left:50%/slide transform conflicts */
.link-test-cases-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11000;
  animation: instantModalOverlayFadeIn 0.12s ease-out;
}

.link-test-cases-modal-panel {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  transform: none !important;
  animation: none !important;
  transition: none !important;
  max-width: none !important;
  width: min(1100px, 90vw);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.modal.create-project-modal {
  width: 50vw;
  max-width: 70vw;
  background-color: #fff;
  border-radius: 8px;
}

/* Delete Confirmation Modal Styles — flex-centered; avoid global .modal
   left:50%/slide transform conflicts so it opens as a centered modal. */
.modal.delete-confirmation-modal {
  width: 90%;
  max-width: 450px;
  background-color: white;
  border-radius: 0.75rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  transform: none !important;
  animation: none !important;
  transition: none !important;
}

.delete-confirmation-modal .modal-header {
  padding: 1.5rem;
  background-color: var(--bg-secondary, #f8f9fa);
  border-bottom: 1px solid var(--border-color, #e9ecef);
  border-radius: 0.75rem 0.75rem 0 0;
}

.delete-confirmation-modal .modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
}

.delete-confirmation-modal .modal-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted, #666);
  border-radius: 0.4rem;
  transition: all 0.2s ease;
}

.delete-confirmation-modal .modal-close-btn:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.1);
  color: var(--text-primary, #1a1a1a);
}

.delete-confirmation-modal .modal-close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.delete-confirmation-modal .modal-body {
  padding: 2rem 1.5rem;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-confirmation-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
}

.delete-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.delete-icon svg {
  width: 32px;
  height: 32px;
}

.delete-message {
  margin: 0;
  color: var(--text-primary, #1a1a1a);
  font-size: 1rem;
  line-height: 1.5;
}

.delete-confirmation-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.5rem;
  border-top: 1px solid var(--border-color, #e9ecef);
  background-color: var(--bg-secondary, #f8f9fa);
  border-radius: 0 0 0.75rem 0.75rem;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-family: inherit;
}

.btn-danger:hover:not(:disabled) {
  background-color: #c82333;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

.btn-danger:active:not(:disabled) {
  transform: translateY(0);
}

.btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.loading-spinner-small {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@media (max-width: 480px) {
  .modal.delete-confirmation-modal {
    width: 95%;
    max-width: none;
  }

  .delete-confirmation-modal .modal-footer {
    flex-direction: column-reverse;
  }

  .delete-confirmation-modal .modal-footer .btn {
    width: 100%;
  }
}

/* Create Test Case modals — scoped to avoid global .modal slide/transform conflicts */
@keyframes instantModalOverlayFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.create-test-case-modal-overlay,
.create-test-case-options-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--modal-backdrop, rgba(0, 0, 0, 0.65));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 12000;
  animation: instantModalOverlayFadeIn 0.12s ease-out;
}

.create-test-case-modal-panel {
  background: var(--modal-background, var(--surface, #fff));
  color: var(--text-primary);
  border: 1px solid var(--border, transparent);
  border-radius: 12px;
  width: 92%;
  max-width: 760px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  transform: none;
}

.create-test-case-modal-panel .modal-header {
  background: var(--modal-background, var(--surface, #fff));
  padding: 1.15rem 1.5rem;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  border-radius: 12px 12px 0 0;
  flex-shrink: 0;
}

.create-test-case-modal-panel .modal-header h2 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
}

.create-test-case-modal-panel .modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.create-test-case-modal-panel .modal-close:hover {
  background: var(--surface-hover);
  color: var(--text-primary);
}

.create-test-case-modal-panel .modal-body {
  padding: 1.25rem 1.5rem;
  overflow-y: auto;
  flex: 1 1;
  background-color: var(--bg-primary);
}

.create-test-case-modal-panel .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
}

.create-test-case-modal-panel .form-row {
  display: flex;
  gap: 1rem;
}

.create-test-case-modal-panel .form-row .form-group {
  flex: 1 1;
}

.create-test-case-options-modal-panel {
  background: var(--modal-background, var(--surface, #fff));
  color: var(--text-primary);
  border: 1px solid var(--border, transparent);
  border-radius: 12px;
  width: 100%;
  max-width: 28rem;
  margin: 0 1rem;
  overflow: hidden;
  box-shadow: var(--shadow-lg, 0 10px 30px rgba(0, 0, 0, 0.35));
  transform: none;
}

.create-test-case-options-modal-header {
  background: var(--modal-background, var(--surface, #fff));
  padding: 1.35rem 1.5rem;
  border-bottom: 1px solid var(--border, #e2e8f0);
}

.create-test-case-options-modal-header h2 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
}

.create-test-case-options-modal-header p {
  margin: 0.25rem 0 0;
  font-size: 0.8125rem;
  color: var(--text-secondary, #475569);
}

.create-test-case-options-modal-body {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.create-test-case-options-modal-footer {
  background-color: var(--modal-background, #fff);
  border-top: 1px solid var(--border, #e5e7eb);
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
}

.create-test-case-option-btn {
  width: 100%;
  padding: 1rem;
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 10px;
  background: var(--surface-raised, #fff);
  color: var(--text-primary);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.create-test-case-option-btn:hover {
  border-color: #3b82f6;
  background-color: #eff6ff;
}

.create-test-case-option-btn.extension:hover {
  border-color: #22c55e;
  background-color: #f0fdf4;
}

.create-test-case-option-btn.disabled {
  position: relative;
  cursor: not-allowed;
  opacity: 0.7;
}

.create-test-case-option-btn.disabled:hover {
  border-color: #e5e7eb;
  background-color: #f9fafb;
}

.create-test-case-option-btn.disabled:hover .create-test-case-option-icon.manual {
  background-color: #dbeafe;
}

.create-test-case-option-coming-soon {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  padding: 0.25rem 0.625rem;
  border-radius: 9999px;
  background-color: #e5e7eb;
  color: #4b5563;
  font-size: 0.75rem;
  font-weight: 600;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
}

.create-test-case-option-btn.disabled:hover .create-test-case-option-coming-soon {
  opacity: 1;
}

.create-test-case-option-asterisk {
  color: #ef4444;
  font-weight: 700;
  margin-left: 0.25rem;
  cursor: help;
}

.create-test-case-option-btn-inner {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.create-test-case-option-icon {
  flex-shrink: 0;
  margin-top: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 8px;
}

.create-test-case-option-icon.manual {
  background-color: #dbeafe;
}

.create-test-case-option-btn:hover .create-test-case-option-icon.manual {
  background-color: #bfdbfe;
}

.create-test-case-option-icon.extension {
  background-color: #dcfce7;
}

.create-test-case-option-btn.extension:hover .create-test-case-option-icon.extension {
  background-color: #bbf7d0;
}

/* Compile and Generate scripts options modal */
.compile-scripts-modal-overlay {
  padding: 1rem;
  box-sizing: border-box;
}

.compile-scripts-modal-panel {
  max-width: 32rem;
  margin: 0;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  display: flex;
  flex-direction: column;
}

.compile-scripts-modal-header {
  flex-shrink: 0;
  padding: 1.25rem 1.5rem;
}

.compile-scripts-modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.compile-scripts-options {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.compile-scripts-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.compile-scripts-option {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 0.875rem 1rem;
  border: 1px solid var(--border, #e5e7eb);
  border-radius: 10px;
  background: var(--surface-raised, #fff);
  color: var(--text-primary);
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}

.compile-scripts-option:hover {
  border-color: rgba(37, 99, 235, 0.45);
}

.compile-scripts-option.is-selected {
  border-color: var(--primary, #2563eb);
  background-color: rgba(37, 99, 235, 0.08);
  box-shadow: 0 0 0 1px var(--primary, #2563eb);
}

.compile-scripts-option:focus-within {
  outline: 2px solid rgba(37, 99, 235, 0.45);
  outline-offset: 2px;
}

.compile-scripts-options:disabled .compile-scripts-option {
  cursor: not-allowed;
  opacity: 0.7;
}

.compile-scripts-option-radio {
  flex-shrink: 0;
  width: 1.125rem;
  height: 1.125rem;
  margin: 0;
  accent-color: var(--primary, #2563eb);
  cursor: inherit;
}

.compile-scripts-option-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 8px;
}

.compile-scripts-option-icon.compile-manual {
  background-color: rgba(37, 99, 235, 0.14);
}

.compile-scripts-option-icon.compile-ai {
  background-color: rgba(124, 58, 237, 0.14);
}

.compile-scripts-option-icon.compile-both {
  background-color: rgba(22, 163, 74, 0.14);
}

.compile-scripts-option-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.compile-scripts-option-title {
  font-weight: 600;
  color: var(--text-primary, #111827);
}

.compile-scripts-option-desc {
  margin-top: 0.125rem;
  font-size: 0.875rem;
  color: var(--text-secondary, #4b5563);
}

.compile-scripts-error {
  padding: 0.75rem 1rem;
  border: 1px solid rgba(239, 68, 68, 0.35);
  border-radius: 8px;
  background-color: rgba(239, 68, 68, 0.08);
  color: var(--danger, #dc2626);
  font-size: 0.875rem;
  overflow-wrap: anywhere;
}

.compile-scripts-modal-footer {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--border, #e5e7eb);
  background-color: var(--modal-background, #fff);
}

.compile-scripts-cancel-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.compile-scripts-generate-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1.125rem;
  border: 1px solid transparent;
  border-radius: 8px;
  background-color: var(--primary, #2563eb);
  color: #fff;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, opacity 0.15s ease;
}

.compile-scripts-generate-btn:hover:not(:disabled) {
  background-color: var(--primary-hover, #1d4ed8);
}

.compile-scripts-generate-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.compile-scripts-spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: compileScriptsSpin 0.8s linear infinite;
}

@keyframes compileScriptsSpin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 576px) {
  .compile-scripts-modal-overlay {
    padding: 0.75rem;
  }

  .compile-scripts-modal-panel {
    max-height: calc(100vh - 1.5rem);
    max-height: calc(100dvh - 1.5rem);
  }

  .compile-scripts-modal-header {
    padding: 1rem;
  }

  .compile-scripts-modal-header h2 {
    font-size: 1.0625rem;
  }

  .compile-scripts-modal-body {
    padding: 1rem;
  }

  .compile-scripts-option {
    padding: 0.75rem;
    gap: 0.75rem;
  }

  .compile-scripts-option-icon {
    display: none;
  }

  .compile-scripts-option-desc {
    font-size: 0.8125rem;
  }

  .compile-scripts-modal-footer {
    flex-direction: column-reverse;
    align-items: stretch;
    padding: 0.875rem 1rem;
    gap: 0.5rem;
  }

  .compile-scripts-modal-footer button {
    width: 100%;
    justify-content: center;
  }
}

.create-test-case-option-title {
  margin: 0;
  font-weight: 600;
  color: var(--text-primary, #111827);
}

.create-test-case-option-desc {
  margin: 0.25rem 0 0;
  font-size: 0.875rem;
  color: var(--text-secondary, #4b5563);
}

.create-test-case-options-cancel-btn {
  padding: 0.5rem 1rem;
  font-weight: 500;
  color: var(--text-secondary, #374151);
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.create-test-case-options-cancel-btn:hover {
  background-color: var(--surface-hover, #e5e7eb);
  color: var(--text-primary);
}

@media (max-width: 576px) {
  .create-test-case-modal-panel .form-row {
    flex-direction: column;
    gap: 0;
  }
}

/* Manual test case form — scoped to the create test case modal */
.create-test-case-modal-panel .ctc-header-subtitle {
  margin: 0.2rem 0 0;
  font-size: 0.8rem;
  color: var(--rt-text-muted, var(--text-secondary, #64748b));
}

.create-test-case-modal-panel .modal-close:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.create-test-case-modal-panel .create-test-case-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.create-test-case-modal-panel .ctc-section {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 1rem 1.15rem 0.35rem;
}

.create-test-case-modal-panel .ctc-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.85rem;
}

.create-test-case-modal-panel .ctc-section-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.create-test-case-modal-panel .ctc-project-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  max-width: 260px;
  padding: 0.25rem 0.6rem;
  border-radius: 9999px;
  background-color: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.create-test-case-modal-panel .ctc-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 1rem;
}

.create-test-case-modal-panel .form-group {
  margin-bottom: 0.85rem;
}

.create-test-case-modal-panel .form-group label {
  display: block;
  margin-bottom: 0.3rem;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.create-test-case-modal-panel .form-input {
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem 0.65rem;
  border: 1px solid var(--input-border);
  border-radius: 6px;
  font-size: 0.85rem;
  color: var(--text-primary);
  background-color: var(--input-background);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.create-test-case-modal-panel textarea.form-input {
  resize: vertical;
  min-height: 2.4rem;
}

.create-test-case-modal-panel .form-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: var(--focus-ring);
}

.create-test-case-modal-panel .form-input:disabled {
  background-color: var(--surface-disabled);
  color: var(--text-muted);
  cursor: not-allowed;
}

.create-test-case-modal-panel .ctc-required {
  color: var(--danger);
}

.create-test-case-modal-panel .ctc-optional {
  color: var(--text-subtle);
  font-weight: 400;
  font-size: 0.75rem;
}

.create-test-case-modal-panel .ctc-section-hint {
  font-size: 0.75rem;
  color: var(--text-subtle);
}

.create-test-case-modal-panel .ctc-steps-section {
  padding-bottom: 1rem;
}

.create-test-case-modal-panel .ctc-lists {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.create-test-case-modal-panel .ctc-list-card {
  border: 1px solid var(--border);
  border-left: 3px solid var(--ctc-accent, #93c5fd);
  border-radius: 8px;
  background-color: var(--bg-tertiary);
  padding: 0.75rem 0.85rem;
}

.create-test-case-modal-panel .ctc-accent-blue {
  --ctc-accent: #60a5fa;
  --ctc-accent-soft: #eff6ff;
  --ctc-accent-strong: #1d4ed8;
}

.create-test-case-modal-panel .ctc-accent-green {
  --ctc-accent: #4ade80;
  --ctc-accent-soft: #f0fdf4;
  --ctc-accent-strong: #15803d;
}

.create-test-case-modal-panel .ctc-accent-amber {
  --ctc-accent: #fbbf24;
  --ctc-accent-soft: #fffbeb;
  --ctc-accent-strong: #b45309;
}

.create-test-case-modal-panel .ctc-accent-slate {
  --ctc-accent: #cbd5e1;
  --ctc-accent-soft: #f8fafc;
  --ctc-accent-strong: #475569;
}

.create-test-case-modal-panel .ctc-list-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  flex-wrap: wrap;
  margin-bottom: 0.6rem;
}

.create-test-case-modal-panel .ctc-list-heading {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  min-width: 0;
}

.create-test-case-modal-panel .ctc-list-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  flex-shrink: 0;
  border-radius: 6px;
  background-color: var(--ctc-accent-soft, #eff6ff);
  color: var(--ctc-accent-strong, #1d4ed8);
}

.create-test-case-modal-panel .ctc-list-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.create-test-case-modal-panel .ctc-list-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.35rem;
  flex-shrink: 0;
  border-radius: 9999px;
  background-color: var(--ctc-accent-soft, #eff6ff);
  color: var(--ctc-accent-strong, #1d4ed8);
  font-size: 0.7rem;
  font-weight: 600;
}

.create-test-case-modal-panel .ctc-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  flex-shrink: 0;
  padding: 0.3rem 0.65rem;
  border: 1px dashed var(--ctc-accent, #93c5fd);
  border-radius: 6px;
  background-color: var(--ctc-accent-soft, #eff6ff);
  color: var(--ctc-accent-strong, #1d4ed8);
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-style 0.15s ease, filter 0.15s ease;
}

.create-test-case-modal-panel .ctc-add-btn:hover {
  border-style: solid;
  filter: brightness(0.97);
}

.create-test-case-modal-panel .ctc-list-items {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.create-test-case-modal-panel .ctc-list-row {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

.create-test-case-modal-panel .ctc-row-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  margin-top: 0.3rem;
  flex-shrink: 0;
  border-radius: 9999px;
  background-color: var(--surface);
  border: 1px solid var(--ctc-accent, #93c5fd);
  color: var(--ctc-accent-strong, #1d4ed8);
  font-size: 0.7rem;
  font-weight: 600;
}

.create-test-case-modal-panel .ctc-row-input {
  flex: 1 1;
  min-width: 0;
}

.create-test-case-modal-panel .ctc-remove-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  margin-top: 0.15rem;
  flex-shrink: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--text-subtle);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.create-test-case-modal-panel .ctc-remove-btn:hover:not(:disabled) {
  background-color: var(--danger-muted);
  color: var(--danger);
}

.create-test-case-modal-panel .ctc-remove-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.create-test-case-modal-panel .ctc-error {
  padding: 0.65rem 0.85rem;
  border: 1px solid color-mix(in srgb, var(--danger) 35%, transparent);
  border-radius: 8px;
  background-color: var(--danger-muted);
  color: var(--danger);
  font-size: 0.82rem;
}

.create-test-case-modal-panel .modal-footer {
  background-color: var(--modal-background, var(--surface));
  border-radius: 0 0 12px 12px;
}

/* Dark: soften the step-list accents so tinted chips don't glow on dark surfaces */
[data-theme="dark"] .create-test-case-modal-panel .ctc-accent-blue {
  --ctc-accent-soft: rgba(96, 165, 250, 0.14);
  --ctc-accent-strong: #93c5fd;
}

[data-theme="dark"] .create-test-case-modal-panel .ctc-accent-green {
  --ctc-accent-soft: rgba(74, 222, 128, 0.14);
  --ctc-accent-strong: #86efac;
}

[data-theme="dark"] .create-test-case-modal-panel .ctc-accent-amber {
  --ctc-accent-soft: rgba(251, 191, 36, 0.14);
  --ctc-accent-strong: #fcd34d;
}

[data-theme="dark"] .create-test-case-modal-panel .ctc-accent-slate {
  --ctc-accent: #64748b;
  --ctc-accent-soft: rgba(148, 163, 184, 0.14);
  --ctc-accent-strong: #cbd5e1;
}

.create-test-case-modal-panel .modal-footer .btn-outline {
  background: var(--surface);
  border: 1px solid var(--border-strong);
  color: var(--text-primary);
}

.create-test-case-modal-panel .modal-footer .btn-outline:hover:not(:disabled) {
  background: var(--surface-hover);
}

@media (max-width: 768px) {
  .create-test-case-modal-panel .ctc-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 576px) {
  .create-test-case-modal-panel {
    width: 100%;
    max-height: 100vh;
    border-radius: 0;
  }

  .create-test-case-modal-panel .modal-header {
    border-radius: 0;
  }

  .create-test-case-modal-panel .modal-body {
    padding: 1rem;
  }

  .create-test-case-modal-panel .modal-footer {
    border-radius: 0;
  }

  .create-test-case-modal-panel .ctc-project-chip {
    max-width: 100%;
  }
}



/* Extension Recording modal — scoped to avoid transform conflicts with native selects */
.extension-recording-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--modal-backdrop, rgba(0, 0, 0, 0.65));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 12000;
  animation: instantModalOverlayFadeIn 0.12s ease-out;
}

.extension-recording-modal-panel {
  background: var(--modal-background, var(--surface, #fff));
  color: var(--text-primary);
  border: 1px solid var(--border, transparent);
  border-radius: 12px;
  width: 100%;
  max-width: 28rem;
  min-width: 0;
  margin: 0 1rem;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transform: none;
}

.extension-recording-modal-panel form {
  min-width: 0;
  overflow-x: hidden;
}

.extension-recording-modal-panel .recording-form-field {
  min-width: 0;
  max-width: 100%;
}

.extension-recording-modal-panel .recording-form-field input,
.extension-recording-modal-panel .recording-form-field textarea {
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: auto;
}

.extension-recording-modal-panel .recording-form-field-error {
  overflow-wrap: anywhere;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modal.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,wCAAwC;EACxC;;;;;;iCAM+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,yDAAyD;EACzD,mCAAmC;EACnC,+CAA+C;EAC/C,4BAA4B;AAC9B;;AAEA;gEACgE;AAChE;;EAEE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mDAAmD;AACrD;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB,EAAE,kCAAkC;EACpD,kBAAkB,EAAE,sDAAsD;EAC1E,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;qBAEmB;EACnB,eAAe;AACjB;;AAEA;EACE;;;;uDAIqD;EACrD,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;;;;;;;2CAOyC;EACzC,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;;AAEb;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;;EAEzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;EACpC,8CAA8C;;AAEhD;;AAEA,+CAA+C;AAC/C;;EAEE,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA,qCAAqC;AACrC;;EAEE,gBAAgB;EAChB,mBAAmB;;AAErB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;;AAE3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,sGAAsG;AACtG;;;;;;EAME,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,kGAAkG;AAClG;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;wEACwE;AACxE;EACE,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,qFAAqF;EACrF,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,8CAA8C;EAC9C,qDAAqD;EACrD,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kDAAkD;EAClD,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,sFAAsF;AACtF;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,yDAAyD;EACzD,0BAA0B;EAC1B,4CAA4C;EAC5C,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yDAAyD;EACzD,uBAAuB;EACvB,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;EACP,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yDAAyD;EACzD,0BAA0B;EAC1B,4CAA4C;EAC5C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE,yDAAyD;EACzD,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+CAA+C;EAC/C,4CAA4C;EAC5C,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;EACnB,uCAAuC;EACvC,0BAA0B;EAC1B,eAAe;EACf,uFAAuF;AACzF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,kBAAkB;EAClB,yCAAyC;EACzC,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,MAAM;EACR;AACF;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,yCAAyC;EACzC,0DAA0D;AAC5D;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,iDAAiD;EACjD,kBAAkB;EAClB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,iDAAiD;EACjD,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,iDAAiD;EACjD,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,gCAAgC;EAChC,4CAA4C;EAC5C,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,oEAAoE;EACpE,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,4BAA4B;AAC9B;;AAEA,mFAAmF;AACnF;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;;;AAIA,wFAAwF;AACxF;EACE,eAAe;EACf,QAAQ;EACR,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,yDAAyD;EACzD,0BAA0B;EAC1B,4CAA4C;EAC5C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB","sourcesContent":["/* Modal Styles */\n.modal-overlay {\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-container {\n  background-color: white;\n  border-radius: 8px;\n  /* max-height: 90vh; */\n  overflow-y: auto;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  width: 90%;\n  max-width: 600px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease; */\n}\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1.15rem 1.35rem;\n  background: var(--modal-background, var(--surface, #fff));\n  color: var(--text-primary, #0f172a);\n  border-bottom: 1px solid var(--border, #e2e8f0);\n  border-radius: 16px 16px 0 0;\n}\n\n/* Create / Edit Test Suite modals — above fixed navbar (z-index 10000) and\n   without inheriting global .modal slide/transform conflicts. */\n.create-test-suite-modal-overlay,\n.edit-test-suite-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 11000;\n  animation: instantModalOverlayFadeIn 0.12s ease-out;\n}\n\n.modal.create-test-suite-modal,\n.modal.edit-test-suite-modal {\n  border-radius: 8px;\n  overflow-y: auto; /* keep modal content scrollable */\n  overflow-x: hidden; /* prevent any horizontal bleed past rounded corners */\n  background-color: #fff;\n  position: fixed !important;\n  top: 50% !important;\n  left: 50% !important;\n  right: auto !important;\n  bottom: auto !important;\n  transform: translate(-50%, -50%) !important;\n  animation: none !important;\n  transition: none !important;\n  z-index: 11001 !important;\n  max-height: min(90vh, calc(100vh - 2rem)) !important;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--text-primary, #0f172a);\n}\n\n.close-button {\n  background: none;\n  border: none;\n  color: var(--text-muted, #64748b);\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0.25rem;\n  line-height: 1;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.close-button:hover {\n  background: var(--surface-hover, #f8fafc);\n  color: var(--text-primary, #0f172a);\n  opacity: 1;\n}\n\n.close-button:active {\n  transform: rotate(90deg) scale(0.95);\n}\n\n.modal-content {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-color, #e9ecef);\n}\n\n/* Form Styles */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: var(--text-primary, #212529);\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border-color, #ced4da);\n  border-radius: 4px;\n  font-size: 16px;\n  transition: border-color 0.2s ease;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: var(--primary, #0d6efd);\n  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\n}\n\n.form-group small {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--text-muted, #6c757d);\n}\n\n.form-group small a {\n  color: var(--primary, #0d6efd);\n  text-decoration: none;\n  margin-left: 4px;\n}\n\n.form-group small a:hover {\n  text-decoration: underline;\n}\n\n/* Button Styles */\n.btn-primary {\n  background-color: var(--primary, #0d6efd);\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.btn-primary:hover {\n  background-color: #0b5ed7;\n}\n\n.btn-primary:disabled {\n  background-color: #84b4ff;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background-color: white;\n  color: var(--text-primary, #212529);\n  border: 1px solid var(--border-color, #ced4da);\n  padding: 10px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.btn-secondary:hover {\n  background-color: var(--bg-light, #f8f9fa);\n}\n\n.btn-link {\n  background: none;\n  border: none;\n  color: var(--primary, #0d6efd);\n  padding: 0;\n  font-size: 14px;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.btn-link:hover {\n  text-decoration: underline;\n}\n\n/* Project Selection Styles */\n.project-selection-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.project-selection-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.project-list {\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid var(--border-color, #e9ecef);\n  border-radius: 4px;\n  margin-bottom: 16px;\n}\n\n.project-item {\n  display: flex;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-color, #e9ecef);\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.project-item:last-child {\n  border-bottom: none;\n}\n\n.project-item:hover {\n  background-color: var(--bg-light, #f8f9fa);\n}\n\n.project-item.selected {\n  background-color: rgba(13, 110, 253, 0.05);\n}\n\n.project-item .checkbox {\n  margin-right: 12px;\n  display: flex;\n  align-items: flex-start;\n  padding-top: 2px;\n}\n\n.project-item .project-info {\n  flex: 1;\n}\n\n.project-item .project-name {\n  margin-bottom: 4px;\n}\n\n.project-item .project-key {\n  font-size: 12px;\n  color: var(--text-muted, #6c757d);\n  background-color: var(--bg-light, #f8f9fa);\n  padding: 2px 6px;\n  border-radius: 4px;\n  margin-left: 8px;\n}\n\n.project-item .project-description {\n  font-size: 14px;\n  color: var(--text-primary, #212529);\n  margin-bottom: 4px;\n}\n\n.project-item .project-lead {\n  font-size: 12px;\n  color: var(--text-muted, #6c757d);\n}\n\n/* File Upload Styles */\n.upload-container {\n  margin: 20px 0;\n}\n\n.file-upload-area {\n  border: 2px dashed var(--border-color, #ced4da);\n  border-radius: 8px;\n  padding: 20px;\n  text-align: center;\n  margin-bottom: 16px;\n  transition: border-color 0.2s ease;\n}\n\n.file-upload-area:hover {\n  border-color: var(--primary, #0d6efd);\n}\n\n.file-upload-label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  padding: 20px;\n}\n\n.file-upload-label.disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.file-upload-label svg {\n  color: var(--primary, #0d6efd);\n}\n\n.file-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--bg-light, #f8f9fa);\n  padding: 8px 12px;\n  border-radius: 4px;\n  margin-top: 12px;\n  width: 100%;\n}\n\n.upload-progress {\n  margin: 16px 0;\n}\n\n.progress-bar {\n  height: 8px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background-color: var(--primary, #0d6efd);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n  color: var(--text-dark, #212529) !important;\n}\n\n.upload-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #dc3545;\n  background-color: #f8d7da;\n  border: 1px solid #f5c2c7;\n  border-radius: 4px;\n  padding: 10px 12px;\n  margin-top: 12px;\n  font-size: 14px;\n}\n\n.upload-info {\n  margin-top: 24px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.upload-info h3 {\n  font-size: 16px;\n  margin-top: 0;\n  margin-bottom: 12px;\n}\n\n.upload-info ol {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.upload-info li {\n  margin-bottom: 8px;\n}\n\n.upload-info li:last-child {\n  margin-bottom: 0;\n}\n\n.modal-body {\n  /* padding: 24px;\n  overflow-y: auto;\n  max-height: 60vh; */\n  padding: 1.5rem;\n}\n\n.modal-footer {\n  /* display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-color, #e9ecef); */\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.modal-cancel-btn {\n  /* background-color: white;\n  color: var(--text-primary, #212529);\n  border: 1px solid var(--border-color, #ced4da);\n  padding: 10px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease; */\n  padding: 0.5rem 1rem;\n  background: #F5F5F5;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #333;\n\n}\n\n.modal-cancel-btn:hover {\n  /* background-color: var(--bg-light, #f8f9fa); */\n  background: #E9E9E9;\n  color: #333;\n}\n\n.modal-cancel-btn:disabled {\n  /* opacity: 0.7; */\n  background: #cccccc;\n  cursor: not-allowed;\n}\n\n.modal-action-btn {\n  background-color: var(--primary, #0d6efd);\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.modal-action-btn:hover {\n  background-color: #0b5ed7;\n}\n\n.modal-action-btn:disabled {\n  background-color: #84b4ff;\n  cursor: not-allowed;\n}\n\n.modal-description {\n  color: var(--text-muted, #6c757d);\n  margin-bottom: 20px;\n}\n\n/* Checkbox Styles */\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: auto;\n  margin: 0;\n  cursor: pointer;\n}\n\n.checkbox-label span {\n  font-size: 14px;\n  color: var(--text-primary, #212529);\n}\n\n/* Error Message */\n.error-message {\n  color: #dc3545;\n  background-color: #f8d7da;\n  border: 1px solid #f5c2c7;\n  border-radius: 4px;\n  padding: 10px 12px;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n/* Stats Group Styles for Edit Modal */\n.stats-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 8px;\n  background-color: var(--bg-light, #f8f9fa);\n  padding: 12px;\n  border-radius: 4px;\n}\n\n.stat-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.stat-label {\n  font-weight: 500;\n  color: var(--text-primary, #212529);\n}\n\n.stat-value {\n  color: var(--primary, #0d6efd);\n  font-weight: 600;\n}\n\n/* Edit Test Suite Modal Specific Styles */\n.edit-test-suite-modal .form-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border-color, #ced4da);\n  border-radius: 4px;\n  font-size: 16px;\n  transition: border-color 0.2s ease;\n}\n\n.edit-test-suite-modal .form-input:focus {\n  outline: none;\n  border-color: var(--primary, #0d6efd);\n  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\n}\n\n.form-error {\n  color: #dc3545;\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n \n.modal.view-mode {\n  width: 60vw;\n  max-width: 70vw;\n  background-color: #e0e0e0;\n\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.modal-body {\n  overflow-y: auto;\n  max-height: 70vh;\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);\n}\n\n.modal-body::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.modal-body::-webkit-scrollbar-track {\n  background: var(--scrollbar-track);\n}\n\n.modal-body::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 4px;\n}\n\n.modal-body::-webkit-scrollbar-thumb:hover {\n  background: var(--scrollbar-thumb-hover);\n}\n\n/* Background for the modal */\n.view-mode {\n  background-color: #f1f3f5 !important;\n  border: 1px solid var(--border-color, #e9ecef);\n\n}\n\n/* Input and textarea styles inside view-mode */\n.view-mode input:disabled,\n.view-mode textarea:disabled {\n  background-color: lightgray !important;\n  color: #020202 !important;\n  cursor: not-allowed;\n  border: 1px solid light-dark !important;\n}\n\n/* Optional: prevent focus outlines */\n.view-mode input:disabled:focus,\n.view-mode textarea:disabled:focus {\n  outline: #212529;\n  box-shadow: #212529;\n\n}\n\n.btn-primary {\n  background-color: #007bff;\n  /* Bootstrap-style blue */\n  color: white;\n  border: none;\n  padding: 0.5rem 1.2rem;\n  font-size: 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: auto;\n}\n\n.btn-primary:hover {\n  background-color: #0056b3;\n\n}\n\n.modal-close {\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n  line-height: 1;\n  border-radius: 8px;\n}\n\n.modal-close:hover {\n  background: var(--surface-hover, #f8fafc);\n  color: var(--text-primary, #0f172a);\n}\n\n.modal-header {\n  background: var(--modal-background, var(--surface, #fff));\n}\n\n.modal.delete-confirm-modal {\n  width: 90%;\n  max-width: 450px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  top: auto;\n  left: auto;\n  transform: none;\n}\n\n.delete-confirm-modal .modal-body {\n  padding: 1.5rem;\n  text-align: center;\n}\n\n.delete-confirm-modal .modal-body p {\n  margin: 0 0 0.75rem;\n}\n\n.delete-confirm-modal .delete-confirm-item-name {\n  font-size: 1.125rem;\n  word-break: break-word;\n}\n\n.delete-confirm-modal .modal-footer {\n  justify-content: space-between;\n}\n\n@media (max-width: 480px) {\n  .modal.delete-confirm-modal {\n    width: 95%;\n    max-width: none;\n  }\n}\n\n/* Test Case action modals should open already centered, without inheriting global slide animations. */\n.modal.ai-suggestions-modal,\n.modal.review-panel-modal,\n.modal.auto-update-modal,\n.modal.version-history-modal,\n.modal.edit-test-case-modal,\n.modal.add-test-cases-modal {\n  position: fixed !important;\n  top: 50% !important;\n  left: 50% !important;\n  right: auto !important;\n  bottom: auto !important;\n  transform: translate(-50%, -50%) !important;\n  animation: none !important;\n  transition: none !important;\n}\n\n/* Link Test Cases modal — flex-centered; avoid navbar .modal left:50%/slide transform conflicts */\n.link-test-cases-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 11000;\n  animation: instantModalOverlayFadeIn 0.12s ease-out;\n}\n\n.link-test-cases-modal-panel {\n  position: relative !important;\n  top: auto !important;\n  left: auto !important;\n  right: auto !important;\n  bottom: auto !important;\n  transform: none !important;\n  animation: none !important;\n  transition: none !important;\n  max-width: none !important;\n  width: min(1100px, 90vw);\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.modal.create-project-modal {\n  width: 50vw;\n  max-width: 70vw;\n  background-color: #fff;\n  border-radius: 8px;\n}\n\n/* Delete Confirmation Modal Styles — flex-centered; avoid global .modal\n   left:50%/slide transform conflicts so it opens as a centered modal. */\n.modal.delete-confirmation-modal {\n  width: 90%;\n  max-width: 450px;\n  background-color: white;\n  border-radius: 0.75rem;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  top: auto;\n  left: auto;\n  right: auto;\n  bottom: auto;\n  transform: none !important;\n  animation: none !important;\n  transition: none !important;\n}\n\n.delete-confirmation-modal .modal-header {\n  padding: 1.5rem;\n  background-color: var(--bg-secondary, #f8f9fa);\n  border-bottom: 1px solid var(--border-color, #e9ecef);\n  border-radius: 0.75rem 0.75rem 0 0;\n}\n\n.delete-confirmation-modal .modal-header h2 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary, #1a1a1a);\n}\n\n.delete-confirmation-modal .modal-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted, #666);\n  border-radius: 0.4rem;\n  transition: all 0.2s ease;\n}\n\n.delete-confirmation-modal .modal-close-btn:hover:not(:disabled) {\n  background-color: rgba(0, 0, 0, 0.1);\n  color: var(--text-primary, #1a1a1a);\n}\n\n.delete-confirmation-modal .modal-close-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.delete-confirmation-modal .modal-body {\n  padding: 2rem 1.5rem;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-confirmation-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  text-align: center;\n}\n\n.delete-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.delete-icon svg {\n  width: 32px;\n  height: 32px;\n}\n\n.delete-message {\n  margin: 0;\n  color: var(--text-primary, #1a1a1a);\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.delete-confirmation-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.5rem;\n  border-top: 1px solid var(--border-color, #e9ecef);\n  background-color: var(--bg-secondary, #f8f9fa);\n  border-radius: 0 0 0.75rem 0.75rem;\n}\n\n.btn-danger {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  font-family: inherit;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: #c82333;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\n}\n\n.btn-danger:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.loading-spinner-small {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@media (max-width: 480px) {\n  .modal.delete-confirmation-modal {\n    width: 95%;\n    max-width: none;\n  }\n\n  .delete-confirmation-modal .modal-footer {\n    flex-direction: column-reverse;\n  }\n\n  .delete-confirmation-modal .modal-footer .btn {\n    width: 100%;\n  }\n}\n\n/* Create Test Case modals — scoped to avoid global .modal slide/transform conflicts */\n@keyframes instantModalOverlayFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.create-test-case-modal-overlay,\n.create-test-case-options-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--modal-backdrop, rgba(0, 0, 0, 0.65));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 12000;\n  animation: instantModalOverlayFadeIn 0.12s ease-out;\n}\n\n.create-test-case-modal-panel {\n  background: var(--modal-background, var(--surface, #fff));\n  color: var(--text-primary);\n  border: 1px solid var(--border, transparent);\n  border-radius: 12px;\n  width: 92%;\n  max-width: 760px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  transform: none;\n}\n\n.create-test-case-modal-panel .modal-header {\n  background: var(--modal-background, var(--surface, #fff));\n  padding: 1.15rem 1.5rem;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  border-radius: 12px 12px 0 0;\n  flex-shrink: 0;\n}\n\n.create-test-case-modal-panel .modal-header h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.create-test-case-modal-panel .modal-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--text-muted);\n  padding: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n.create-test-case-modal-panel .modal-close:hover {\n  background: var(--surface-hover);\n  color: var(--text-primary);\n}\n\n.create-test-case-modal-panel .modal-body {\n  padding: 1.25rem 1.5rem;\n  overflow-y: auto;\n  flex: 1;\n  background-color: var(--bg-primary);\n}\n\n.create-test-case-modal-panel .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.25rem 1.5rem;\n  border-top: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.create-test-case-modal-panel .form-row {\n  display: flex;\n  gap: 1rem;\n}\n\n.create-test-case-modal-panel .form-row .form-group {\n  flex: 1;\n}\n\n.create-test-case-options-modal-panel {\n  background: var(--modal-background, var(--surface, #fff));\n  color: var(--text-primary);\n  border: 1px solid var(--border, transparent);\n  border-radius: 12px;\n  width: 100%;\n  max-width: 28rem;\n  margin: 0 1rem;\n  overflow: hidden;\n  box-shadow: var(--shadow-lg, 0 10px 30px rgba(0, 0, 0, 0.35));\n  transform: none;\n}\n\n.create-test-case-options-modal-header {\n  background: var(--modal-background, var(--surface, #fff));\n  padding: 1.35rem 1.5rem;\n  border-bottom: 1px solid var(--border, #e2e8f0);\n}\n\n.create-test-case-options-modal-header h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.create-test-case-options-modal-header p {\n  margin: 0.25rem 0 0;\n  font-size: 0.8125rem;\n  color: var(--text-secondary, #475569);\n}\n\n.create-test-case-options-modal-body {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.create-test-case-options-modal-footer {\n  background-color: var(--modal-background, #fff);\n  border-top: 1px solid var(--border, #e5e7eb);\n  padding: 1rem 1.5rem;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.create-test-case-option-btn {\n  width: 100%;\n  padding: 1rem;\n  border: 1px solid var(--border, #e5e7eb);\n  border-radius: 10px;\n  background: var(--surface-raised, #fff);\n  color: var(--text-primary);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease;\n}\n\n.create-test-case-option-btn:hover {\n  border-color: #3b82f6;\n  background-color: #eff6ff;\n}\n\n.create-test-case-option-btn.extension:hover {\n  border-color: #22c55e;\n  background-color: #f0fdf4;\n}\n\n.create-test-case-option-btn.disabled {\n  position: relative;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.create-test-case-option-btn.disabled:hover {\n  border-color: #e5e7eb;\n  background-color: #f9fafb;\n}\n\n.create-test-case-option-btn.disabled:hover .create-test-case-option-icon.manual {\n  background-color: #dbeafe;\n}\n\n.create-test-case-option-coming-soon {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  padding: 0.25rem 0.625rem;\n  border-radius: 9999px;\n  background-color: #e5e7eb;\n  color: #4b5563;\n  font-size: 0.75rem;\n  font-weight: 600;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.15s ease;\n}\n\n.create-test-case-option-btn.disabled:hover .create-test-case-option-coming-soon {\n  opacity: 1;\n}\n\n.create-test-case-option-asterisk {\n  color: #ef4444;\n  font-weight: 700;\n  margin-left: 0.25rem;\n  cursor: help;\n}\n\n.create-test-case-option-btn-inner {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.create-test-case-option-icon {\n  flex-shrink: 0;\n  margin-top: 0.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 8px;\n}\n\n.create-test-case-option-icon.manual {\n  background-color: #dbeafe;\n}\n\n.create-test-case-option-btn:hover .create-test-case-option-icon.manual {\n  background-color: #bfdbfe;\n}\n\n.create-test-case-option-icon.extension {\n  background-color: #dcfce7;\n}\n\n.create-test-case-option-btn.extension:hover .create-test-case-option-icon.extension {\n  background-color: #bbf7d0;\n}\n\n/* Compile and Generate scripts options modal */\n.compile-scripts-modal-overlay {\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.compile-scripts-modal-panel {\n  max-width: 32rem;\n  margin: 0;\n  max-height: calc(100vh - 2rem);\n  max-height: calc(100dvh - 2rem);\n  display: flex;\n  flex-direction: column;\n}\n\n.compile-scripts-modal-header {\n  flex-shrink: 0;\n  padding: 1.25rem 1.5rem;\n}\n\n.compile-scripts-modal-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.compile-scripts-options {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.compile-scripts-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.compile-scripts-option {\n  display: flex;\n  align-items: center;\n  gap: 0.875rem;\n  padding: 0.875rem 1rem;\n  border: 1px solid var(--border, #e5e7eb);\n  border-radius: 10px;\n  background: var(--surface-raised, #fff);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.compile-scripts-option:hover {\n  border-color: rgba(37, 99, 235, 0.45);\n}\n\n.compile-scripts-option.is-selected {\n  border-color: var(--primary, #2563eb);\n  background-color: rgba(37, 99, 235, 0.08);\n  box-shadow: 0 0 0 1px var(--primary, #2563eb);\n}\n\n.compile-scripts-option:focus-within {\n  outline: 2px solid rgba(37, 99, 235, 0.45);\n  outline-offset: 2px;\n}\n\n.compile-scripts-options:disabled .compile-scripts-option {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.compile-scripts-option-radio {\n  flex-shrink: 0;\n  width: 1.125rem;\n  height: 1.125rem;\n  margin: 0;\n  accent-color: var(--primary, #2563eb);\n  cursor: inherit;\n}\n\n.compile-scripts-option-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  border-radius: 8px;\n}\n\n.compile-scripts-option-icon.compile-manual {\n  background-color: rgba(37, 99, 235, 0.14);\n}\n\n.compile-scripts-option-icon.compile-ai {\n  background-color: rgba(124, 58, 237, 0.14);\n}\n\n.compile-scripts-option-icon.compile-both {\n  background-color: rgba(22, 163, 74, 0.14);\n}\n\n.compile-scripts-option-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.compile-scripts-option-title {\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n}\n\n.compile-scripts-option-desc {\n  margin-top: 0.125rem;\n  font-size: 0.875rem;\n  color: var(--text-secondary, #4b5563);\n}\n\n.compile-scripts-error {\n  padding: 0.75rem 1rem;\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  border-radius: 8px;\n  background-color: rgba(239, 68, 68, 0.08);\n  color: var(--danger, #dc2626);\n  font-size: 0.875rem;\n  overflow-wrap: anywhere;\n}\n\n.compile-scripts-modal-footer {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--border, #e5e7eb);\n  background-color: var(--modal-background, #fff);\n}\n\n.compile-scripts-cancel-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.compile-scripts-generate-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1.125rem;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background-color: var(--primary, #2563eb);\n  color: #fff;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.15s ease, opacity 0.15s ease;\n}\n\n.compile-scripts-generate-btn:hover:not(:disabled) {\n  background-color: var(--primary-hover, #1d4ed8);\n}\n\n.compile-scripts-generate-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.compile-scripts-spinner {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: compileScriptsSpin 0.8s linear infinite;\n}\n\n@keyframes compileScriptsSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 576px) {\n  .compile-scripts-modal-overlay {\n    padding: 0.75rem;\n  }\n\n  .compile-scripts-modal-panel {\n    max-height: calc(100vh - 1.5rem);\n    max-height: calc(100dvh - 1.5rem);\n  }\n\n  .compile-scripts-modal-header {\n    padding: 1rem;\n  }\n\n  .compile-scripts-modal-header h2 {\n    font-size: 1.0625rem;\n  }\n\n  .compile-scripts-modal-body {\n    padding: 1rem;\n  }\n\n  .compile-scripts-option {\n    padding: 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .compile-scripts-option-icon {\n    display: none;\n  }\n\n  .compile-scripts-option-desc {\n    font-size: 0.8125rem;\n  }\n\n  .compile-scripts-modal-footer {\n    flex-direction: column-reverse;\n    align-items: stretch;\n    padding: 0.875rem 1rem;\n    gap: 0.5rem;\n  }\n\n  .compile-scripts-modal-footer button {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n.create-test-case-option-title {\n  margin: 0;\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n}\n\n.create-test-case-option-desc {\n  margin: 0.25rem 0 0;\n  font-size: 0.875rem;\n  color: var(--text-secondary, #4b5563);\n}\n\n.create-test-case-options-cancel-btn {\n  padding: 0.5rem 1rem;\n  font-weight: 500;\n  color: var(--text-secondary, #374151);\n  background: none;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.create-test-case-options-cancel-btn:hover {\n  background-color: var(--surface-hover, #e5e7eb);\n  color: var(--text-primary);\n}\n\n@media (max-width: 576px) {\n  .create-test-case-modal-panel .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n}\n\n/* Manual test case form — scoped to the create test case modal */\n.create-test-case-modal-panel .ctc-header-subtitle {\n  margin: 0.2rem 0 0;\n  font-size: 0.8rem;\n  color: var(--rt-text-muted, var(--text-secondary, #64748b));\n}\n\n.create-test-case-modal-panel .modal-close:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.create-test-case-modal-panel .create-test-case-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.create-test-case-modal-panel .ctc-section {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 1rem 1.15rem 0.35rem;\n}\n\n.create-test-case-modal-panel .ctc-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 0.85rem;\n}\n\n.create-test-case-modal-panel .ctc-section-title {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.create-test-case-modal-panel .ctc-project-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  max-width: 260px;\n  padding: 0.25rem 0.6rem;\n  border-radius: 9999px;\n  background-color: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.create-test-case-modal-panel .ctc-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0 1rem;\n}\n\n.create-test-case-modal-panel .form-group {\n  margin-bottom: 0.85rem;\n}\n\n.create-test-case-modal-panel .form-group label {\n  display: block;\n  margin-bottom: 0.3rem;\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n}\n\n.create-test-case-modal-panel .form-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.5rem 0.65rem;\n  border: 1px solid var(--input-border);\n  border-radius: 6px;\n  font-size: 0.85rem;\n  color: var(--text-primary);\n  background-color: var(--input-background);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.create-test-case-modal-panel textarea.form-input {\n  resize: vertical;\n  min-height: 2.4rem;\n}\n\n.create-test-case-modal-panel .form-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: var(--focus-ring);\n}\n\n.create-test-case-modal-panel .form-input:disabled {\n  background-color: var(--surface-disabled);\n  color: var(--text-muted);\n  cursor: not-allowed;\n}\n\n.create-test-case-modal-panel .ctc-required {\n  color: var(--danger);\n}\n\n.create-test-case-modal-panel .ctc-optional {\n  color: var(--text-subtle);\n  font-weight: 400;\n  font-size: 0.75rem;\n}\n\n.create-test-case-modal-panel .ctc-section-hint {\n  font-size: 0.75rem;\n  color: var(--text-subtle);\n}\n\n.create-test-case-modal-panel .ctc-steps-section {\n  padding-bottom: 1rem;\n}\n\n.create-test-case-modal-panel .ctc-lists {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.create-test-case-modal-panel .ctc-list-card {\n  border: 1px solid var(--border);\n  border-left: 3px solid var(--ctc-accent, #93c5fd);\n  border-radius: 8px;\n  background-color: var(--bg-tertiary);\n  padding: 0.75rem 0.85rem;\n}\n\n.create-test-case-modal-panel .ctc-accent-blue {\n  --ctc-accent: #60a5fa;\n  --ctc-accent-soft: #eff6ff;\n  --ctc-accent-strong: #1d4ed8;\n}\n\n.create-test-case-modal-panel .ctc-accent-green {\n  --ctc-accent: #4ade80;\n  --ctc-accent-soft: #f0fdf4;\n  --ctc-accent-strong: #15803d;\n}\n\n.create-test-case-modal-panel .ctc-accent-amber {\n  --ctc-accent: #fbbf24;\n  --ctc-accent-soft: #fffbeb;\n  --ctc-accent-strong: #b45309;\n}\n\n.create-test-case-modal-panel .ctc-accent-slate {\n  --ctc-accent: #cbd5e1;\n  --ctc-accent-soft: #f8fafc;\n  --ctc-accent-strong: #475569;\n}\n\n.create-test-case-modal-panel .ctc-list-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n  margin-bottom: 0.6rem;\n}\n\n.create-test-case-modal-panel .ctc-list-heading {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-width: 0;\n}\n\n.create-test-case-modal-panel .ctc-list-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.6rem;\n  height: 1.6rem;\n  flex-shrink: 0;\n  border-radius: 6px;\n  background-color: var(--ctc-accent-soft, #eff6ff);\n  color: var(--ctc-accent-strong, #1d4ed8);\n}\n\n.create-test-case-modal-panel .ctc-list-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.create-test-case-modal-panel .ctc-list-count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.25rem;\n  height: 1.25rem;\n  padding: 0 0.35rem;\n  flex-shrink: 0;\n  border-radius: 9999px;\n  background-color: var(--ctc-accent-soft, #eff6ff);\n  color: var(--ctc-accent-strong, #1d4ed8);\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.create-test-case-modal-panel .ctc-add-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  flex-shrink: 0;\n  padding: 0.3rem 0.65rem;\n  border: 1px dashed var(--ctc-accent, #93c5fd);\n  border-radius: 6px;\n  background-color: var(--ctc-accent-soft, #eff6ff);\n  color: var(--ctc-accent-strong, #1d4ed8);\n  font-size: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-style 0.15s ease, filter 0.15s ease;\n}\n\n.create-test-case-modal-panel .ctc-add-btn:hover {\n  border-style: solid;\n  filter: brightness(0.97);\n}\n\n.create-test-case-modal-panel .ctc-list-items {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.create-test-case-modal-panel .ctc-list-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.create-test-case-modal-panel .ctc-row-index {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  margin-top: 0.3rem;\n  flex-shrink: 0;\n  border-radius: 9999px;\n  background-color: var(--surface);\n  border: 1px solid var(--ctc-accent, #93c5fd);\n  color: var(--ctc-accent-strong, #1d4ed8);\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.create-test-case-modal-panel .ctc-row-input {\n  flex: 1;\n  min-width: 0;\n}\n\n.create-test-case-modal-panel .ctc-remove-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.9rem;\n  height: 1.9rem;\n  margin-top: 0.15rem;\n  flex-shrink: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--text-subtle);\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.create-test-case-modal-panel .ctc-remove-btn:hover:not(:disabled) {\n  background-color: var(--danger-muted);\n  color: var(--danger);\n}\n\n.create-test-case-modal-panel .ctc-remove-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.create-test-case-modal-panel .ctc-error {\n  padding: 0.65rem 0.85rem;\n  border: 1px solid color-mix(in srgb, var(--danger) 35%, transparent);\n  border-radius: 8px;\n  background-color: var(--danger-muted);\n  color: var(--danger);\n  font-size: 0.82rem;\n}\n\n.create-test-case-modal-panel .modal-footer {\n  background-color: var(--modal-background, var(--surface));\n  border-radius: 0 0 12px 12px;\n}\n\n/* Dark: soften the step-list accents so tinted chips don't glow on dark surfaces */\n[data-theme=\"dark\"] .create-test-case-modal-panel .ctc-accent-blue {\n  --ctc-accent-soft: rgba(96, 165, 250, 0.14);\n  --ctc-accent-strong: #93c5fd;\n}\n\n[data-theme=\"dark\"] .create-test-case-modal-panel .ctc-accent-green {\n  --ctc-accent-soft: rgba(74, 222, 128, 0.14);\n  --ctc-accent-strong: #86efac;\n}\n\n[data-theme=\"dark\"] .create-test-case-modal-panel .ctc-accent-amber {\n  --ctc-accent-soft: rgba(251, 191, 36, 0.14);\n  --ctc-accent-strong: #fcd34d;\n}\n\n[data-theme=\"dark\"] .create-test-case-modal-panel .ctc-accent-slate {\n  --ctc-accent: #64748b;\n  --ctc-accent-soft: rgba(148, 163, 184, 0.14);\n  --ctc-accent-strong: #cbd5e1;\n}\n\n.create-test-case-modal-panel .modal-footer .btn-outline {\n  background: var(--surface);\n  border: 1px solid var(--border-strong);\n  color: var(--text-primary);\n}\n\n.create-test-case-modal-panel .modal-footer .btn-outline:hover:not(:disabled) {\n  background: var(--surface-hover);\n}\n\n@media (max-width: 768px) {\n  .create-test-case-modal-panel .ctc-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 576px) {\n  .create-test-case-modal-panel {\n    width: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .create-test-case-modal-panel .modal-header {\n    border-radius: 0;\n  }\n\n  .create-test-case-modal-panel .modal-body {\n    padding: 1rem;\n  }\n\n  .create-test-case-modal-panel .modal-footer {\n    border-radius: 0;\n  }\n\n  .create-test-case-modal-panel .ctc-project-chip {\n    max-width: 100%;\n  }\n}\n\n\n\n/* Extension Recording modal — scoped to avoid transform conflicts with native selects */\n.extension-recording-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: var(--modal-backdrop, rgba(0, 0, 0, 0.65));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 12000;\n  animation: instantModalOverlayFadeIn 0.12s ease-out;\n}\n\n.extension-recording-modal-panel {\n  background: var(--modal-background, var(--surface, #fff));\n  color: var(--text-primary);\n  border: 1px solid var(--border, transparent);\n  border-radius: 12px;\n  width: 100%;\n  max-width: 28rem;\n  min-width: 0;\n  margin: 0 1rem;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  transform: none;\n}\n\n.extension-recording-modal-panel form {\n  min-width: 0;\n  overflow-x: hidden;\n}\n\n.extension-recording-modal-panel .recording-form-field {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.extension-recording-modal-panel .recording-form-field input,\n.extension-recording-modal-panel .recording-form-field textarea {\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: auto;\n}\n\n.extension-recording-modal-panel .recording-form-field-error {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
